import { Layout } from '@/utils/routerHelper'

// 库存管理
export default {
  path: '/system',
  redirect: '/system/member',
  component: Layout,
  name: 'System',
  meta: {
    title: '系统管理',
    icon: 'vi-ant-design:dashboard-filled'
  },
  children: [
    {
      path: 'admin',
      redirect: '/system/admin/role',
      name: 'AdminSetting',
      meta: {
        title: '管理员设置',
        alwaysShow: true
      },
      children: [
        {
          path: 'role',
          component: () => import('@/views/System/Admin/Role/Index.vue'),
          name: 'RoleSetting',
          meta: {
            title: '角色管理'
          }
        },
        {
          path: 'menu',
          component: () => import('@/views/System/Admin/menu/Index.vue'),
          name: 'MenuSetting',
          meta: {
            title: '菜单管理'
          }
        },
        {
          path: 'account',
          component: () => import('@/views/System/Admin/Account/Index.vue'),
          name: 'AccountSetting',
          meta: {
            title: '账号管理'
          }
        },
        {
          path: 'white-list',
          component: () => import('@/views/System/Admin/WhiteList/Index.vue'),
          name: 'WhiteListSetting',
          meta: {
            title: '白名单配置'
          }
        }
      ]
    },
    {
      path: 'base',
      redirect: '/system/base/reason',
      name: 'BaseSetting',
      meta: {
        title: '基础信息设置',
        alwaysShow: true
      },
      children: [
        {
          path: 'area',
          component: () => import('@/views/System/Base/Area/Index.vue'),
          name: 'BaseArea',
          meta: {
            title: '地区管理'
          }
        },
        {
          path: 'city-manager',
          component: () => import('@/views/System/Base/CityManager/Index.vue'),
          name: 'BaseCityManager',
          meta: {
            title: '城市经理管理'
          },
          children: [
            {
              path: 'edit-city-manager',
              component: () => import('@/views/System/Base/EditCityManager/Index.vue'),
              name: 'BaseEditCityManager',
              meta: {
                title: '新增城市经理',
                hidden: true,
                canTo: true,
                activeMenu: '/system/base/city-manager'
              }
            }
          ]
        },
        {
          path: 'region',
          component: () => import('@/views/System/Base/Region/Index.vue'),
          name: 'BaseRegion',
          meta: {
            title: '大区管理'
          }
        },
        {
          path: 'nationality',
          component: () => import('@/views/System/Base/Nationality/Index.vue'),
          name: 'BaseNationality',
          meta: {
            title: '民族管理'
          }
        },
        {
          path: 'systems-management',
          component: () => import('@/views/System/Base/SystemsManagement/Index.vue'),
          name: 'BaseSystemsManagement',
          meta: {
            title: '体系管理'
          }
        },
        {
          path: 'agreement',
          component: () => import('@/views/System/Base/Agreement/Index.vue'),
          name: 'BaseAgreement',
          meta: {
            title: '协议管理'
          }
        },
        {
          path: 'reason',
          component: () => import('@/views/System/Base/Reason/Index.vue'),
          name: 'BaseReason',
          meta: {
            title: '原因项管理'
          }
        },
        {
          path: 'store-prefix',
          component: () => import('@/views/System/Base/StorePrefix/Index.vue'),
          name: 'StorePrefix',
          meta: {
            title: '店铺前缀管理'
          }
        },
        {
          path: 'store-logo',
          component: () => import('@/views/System/Base/StoreLogo/Index.vue'),
          name: 'StoreLogo',
          meta: {
            title: '店铺标识管理'
          }
        },

        {
          path: 'friendship-link',
          component: () => import('@/views/System/Base/FriendshipLink/Index.vue'),
          name: 'BaseFriendshipLink',
          meta: {
            title: '友情链接管理'
          }
        },
        {
          path: 'text-message',
          component: () => import('@/views/System/Base/TextMessage/Index.vue'),
          name: 'BaseTextMessage',
          meta: {
            title: '短信通道'
          }
        },
        {
          path: 'opening-bank',
          component: () => import('@/views/System/Base/OpeningBank/Index.vue'),
          name: 'BaseOpeningBank',
          meta: {
            title: '开户行管理'
          }
        },
        {
          path: 'number-reissues',
          component: () => import('@/views/System/Base/NumberReissues/Index.vue'),
          name: 'BaseNumberReissues',
          meta: {
            title: '补发次数'
          }
        }
        // {
        //   path: 'activity-number-reissues',
        //   component: () => import('@/views/System/Base/ActivityNumberReissues/Index.vue'),
        //   name: 'BaseActivityNumberReissues',
        //   meta: {
        //     title: '活动享受次数'
        //   }
        // }
      ]
    },
    {
      path: 'finance',
      redirect: '/system/finance/transaction',
      name: 'FinanceSetting',
      meta: {
        title: '财务设置',
        alwaysShow: true
      },
      children: [
        {
          path: 'transaction',
          component: () => import('@/views/System/Finance/Transaction/Index.vue'),
          name: 'SystemFinanceTransaction',
          meta: {
            title: '交易设置'
          }
        },
        {
          path: 'wallet-payment',
          component: () => import('@/views/System/Finance/WalletPayment/Index.vue'),
          name: 'SystemWalletPayment',
          meta: {
            title: '钱包支付设置'
          }
        },
        {
          path: 'payment-password-lock',
          component: () => import('@/views/System/Finance/PaymentPasswordLock/Index.vue'),
          name: 'SystemPaymentPasswordLock',
          meta: {
            title: '支付密码锁定设置'
          }
        },
        {
          path: 'invoice-apply-time-limit',
          component: () => import('@/views/System/Finance/InvoiceApplyTimeLimit/Index.vue'),
          name: 'SystemInvoiceApplyTimeLimit',
          meta: {
            title: '发票申请时间限制'
          }
        },
        {
          path: 'manual-adjust-type',
          component: () => import('@/views/System/Finance/ManualAdjustType/Index.vue'),
          name: 'SystemManualAdjustType',
          meta: {
            title: '手工调整类型管理'
          }
        },
        {
          path: 'product-tax-rate',
          component: () => import('@/views/System/Finance/ProductTaxRate/Index.vue'),
          name: 'SystemProductTaxRate',
          meta: {
            title: '产品税率设置'
          }
        },
        {
          path: 'remit-bank',
          component: () => import('@/views/System/Finance/RemitBank/Index.vue'),
          name: 'SystemRemitBank',
          meta: {
            title: '汇入银行设置'
          }
        },
        // see https://zentao.a6shop.net/index.php?m=bug&f=view&bugID=992
        /*{
          path: 'payment-channel',
          component: () => import('@/views/System/Finance/PaymentChannel/Index.vue'),
          name: 'SystemPaymentChannel',
          meta: {
            title: '支付渠道设置'
          }
        },*/
        // see https://zentao.a6shop.net/index.php?m=bug&f=view&bugID=993
        /*{
          path: 'channel-commission',
          component: () => import('@/views/System/Finance/ChannelCommission/Index.vue'),
          name: 'SystemChannelCommission',
          meta: {
            title: '渠道手续费设置'
          }
        },*/
        {
          path: 'repair-certificate-template',
          component: () => import('@/views/System/Finance/RepairCertificateTemplate/Index.vue'),
          name: 'SystemRepairCertificateTemplate',
          meta: {
            title: '责任和店补券模板设置'
          }
        },
        {
          path: 'commission-sharing',
          component: () => import('@/views/System/Finance/CommissionSharing/Index.vue'),
          name: 'SystemCommissionSharing',
          meta: {
            title: '非直销区分佣设置'
          }
        },
        {
          path: 'andou-setting',
          component: () => import('@/views/System/Finance/AndouSetting/Index.vue'),
          name: 'SystemAndouSetting',
          meta: {
            title: '安豆使用设置'
          }
        },
        {
          path: 'city-agent-setting',
          component: () => import('@/views/System/Finance/CityAgentSetting/Index.vue'),
          name: 'CityAgentSetting',
          meta: {
            title: '省市代设置'
          }
        }
      ]
    },
    {
      path: 'member',
      redirect: '/system/member/params',
      name: 'MemberSetting',
      meta: {
        title: '会员设置',
        alwaysShow: true
      },
      children: [
        {
          path: 'params',
          component: () => import('@/views/System/Member/Params/Index.vue'),
          name: 'SystemMemberParams',
          meta: {
            title: '会员参数设置'
          }
        },
        {
          path: 'open-card',
          component: () => import('@/views/System/Member/OpenCard/Index.vue'),
          name: 'SystemMemberOpenCard',
          meta: {
            title: '开卡管理'
          }
        },
        {
          path: 'ethnic-restrictions',
          component: () => import('@/views/System/Member/EthnicRestrictions/Index.vue'),
          name: 'SystemMemberEthnicRestrictions',
          meta: {
            title: '民族限制'
          }
        },
        {
          path: 'membership-profession',
          component: () => import('@/views/System/Base/MembershipProfession/Index.vue'),
          name: 'MembershipProfession',
          meta: {
            title: '会员职业配置'
          }
        },
        {
          path: 'auto-allocation',
          component: () => import('@/views/System/Member/AutoAllocation/Index.vue'),
          name: 'SystemMemberAutoAllocation',
          meta: {
            title: '自动分配服务顾问'
          }
        },
        {
          path: 'member-verification-code',
          component: () => import('@/views/System/Member/MemberVerificationCode/Index.vue'),
          name: 'SystemMemberVerificationCode',
          meta: {
            title: '会员超级验证码'
          }
        }
      ]
    },
    {
      path: 'order',
      redirect: '/system/order/first-buy-must',
      name: 'OrderSetting',
      meta: {
        title: '订单设置',
        alwaysShow: true
      },
      children: [
        {
          path: 'pickup-address',
          component: () => import('@/views/System/Order/PickupAddress/Index.vue'),
          name: 'OrderPickupAddress',
          meta: {
            title: '提货地址管理'
          }
        },
        {
          path: 'return-address',
          component: () => import('@/views/System/Order/ReturnAddress/Index.vue'),
          name: 'OrderReturnAddress',
          meta: {
            title: '返货地址管理'
          }
        },
        {
          path: 'first-buy-must',
          component: () => import('@/views/System/Order/FirstBuyMust/Index.vue'),
          name: 'FirstBuyMust',
          meta: {
            title: '首购必选设置'
          }
        },
        {
          path: 'change-or-return',
          component: () => import('@/views/System/Order/ChangeOrRefund/Index.vue'),
          name: 'OrderChangeOrRefund',
          meta: {
            title: '退换货设置'
          }
        },
        {
          path: 'after-sale-keyword',
          component: () => import('@/views/System/Order/AfterSaleKeywords/Index.vue'),
          name: 'OrderAfterSaleKeywords',
          meta: {
            title: '售后关键词配置'
          }
        },
        {
          path: 'change-blacklist',
          component: () => import('@/views/System/Order/ChangeBlacklist/Index.vue'),
          name: 'OrderChangeBlacklist',
          meta: {
            title: '换货黑名单配置'
          }
        },
        {
          path: 'order-freight',
          component: () => import('@/views/System/Order/OrderFreight/Index.vue'),
          name: 'OrderFreight',
          meta: {
            title: '订单运费'
          }
        },
        {
          path: 'change-freight',
          component: () => import('@/views/System/Order/ChangeFreight/Index.vue'),
          name: 'OrderChangeFreight',
          meta: {
            title: '换货运费'
          }
        },
        {
          path: 'sf-freight',
          component: () => import('@/views/System/Order/SFFreight/Index.vue'),
          name: 'SFFreight',
          meta: {
            title: '顺丰到付运费'
          }
        },
        {
          path: 'report',
          component: () => import('@/views/System/Order/OrderReport/Index.vue'),
          name: 'OrderReport',
          meta: {
            title: '订单报单配置'
          }
        }
      ]
    },
    {
      path: 'system-log',
      redirect: '/system/system-log/login-log',
      name: 'SystemLog',
      meta: {
        title: '系统日志',
        alwaysShow: true
      },
      children: [
        {
          path: 'login-log',
          component: () => import('@/views/System/SystemLog/LoginLog/Index.vue'),
          name: 'SystemLogLogin',
          meta: {
            title: '登录日记'
          }
        },
        {
          path: 'operation-log',
          component: () => import('@/views/System/SystemLog/OperationLog/Index.vue'),
          name: 'SystemLogOperation',
          meta: {
            title: '操作日记'
          }
        }
      ]
    }
  ]
} as AppRouteRecordRaw
